export interface DialogBoxData {
    title: string;
    description: string;
}
